<template>
    <v-container id="footer-menu-products-wrapper" class="pa-0" fluid>
        <v-row column>
            <v-col cols="12">
                <h3 class="uppercase widget-heading--footer">
                    <TranslatableStringComponent :tstring="{string: 'ourProducts'}" />
                </h3>
            </v-col>
            <v-col
                v-for="(oneThird, i) in thirds"
                :key="i"
                cols="12"
                md="4"
                class="pt-0 pb-0"
            >
                <v-list>
                    <v-list-item
                        v-for="menuItem in menuInThirds[oneThird]"
                        :key="menuItem._key"
                        class="footer-list-item"
                    >
                        <v-list-item-content>
                            <a
                                v-if="isExternal(menuItem, $i18n.locale)"
                                :href="menuItem.menuItemURLo[$i18n.locale]"
                                class=""
                            >
                                {{ menuItem.menuItemLabel[$i18n.locale] }}
                            </a>
                            <nuxt-link
                                v-else-if="isInternal(menuItem, $i18n.locale)"
                                :to="getCustomLocalePath(menuItem)"
                                nuxt
                                exact
                                class=""
                            >
                                <span>{{
                                    menuItem.menuItemLabel[$i18n.locale]
                                }}</span>
                            </nuxt-link>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import menuUtilities from '~/mixins/menuUtilities'
export default {
    name: 'MenuFooterProducts',
    mixins: [menuUtilities],
    data() {
        return {
            thirds: ['a', 'b', 'c']
        }
    },
    computed: {
        menuInThirds() {
            const menuInThirds = {}
            const stack = Math.floor(this.menu.menuItems.length / 3)
            // console.log(stack)
            menuInThirds.a = this.menu.menuItems.filter((item, i) => {
                return i < stack
            })
            menuInThirds.b = this.menu.menuItems.filter((item, i) => {
                return i >= stack && i < stack * 2
            })
            menuInThirds.c = this.menu.menuItems.filter((item, i) => {
                return i > stack * 2
            })
            return menuInThirds
        }
    }
}
</script>
